/* Peak Moto size guide: draws the chart(s) from the product's
 * pmo.size_chart metafield, switches cm/inches, and runs the calculator
 * (PmoSizeCalc, assets/pmo-size-calc.js). Markup: snippets/pmo-size-guide.liquid. */
(function () {
  "use strict";
  if (customElements.get("pmo-size-guide")) return;

  var IN_PER_CM = 1 / 2.54;
  var TO_CM = { cm: 1, "cm-ft": 1, "ft-cm": 1, mm: 0.1, in: 2.54 };

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }
  function round1(n) {
    return String(Math.round(n * 10) / 10);
  }
  function feetInches(cm) {
    var inches = Math.round(cm * IN_PER_CM);
    return Math.floor(inches / 12) + "'" + (inches % 12) + '"';
  }

  // One cell's text in the chosen units. Ranges convert end by end.
  function showValue(cell, units) {
    var v = String(cell.v == null ? "" : cell.v);
    var u = cell.u;
    if (!u || !/\d/.test(v)) return { text: v, unit: "" };
    var parts = v.split("-");
    var nums = parts.map(function (p) {
      return parseFloat(String(p).replace(",", "."));
    });
    if (nums.some(isNaN)) return { text: v, unit: "" };
    var cms = nums.map(function (n) {
      return n * (TO_CM[u] || 1);
    });
    if (units === "in") {
      if (u === "cm-ft" || u === "ft-cm") return { text: cms.map(feetInches).join(" - "), unit: "" };
      return { text: cms.map(function (c) { return round1(c * IN_PER_CM); }).join(" - "), unit: "in" };
    }
    if (u === "mm") return { text: v, unit: "mm" };
    if (u === "in") return { text: cms.map(round1).join(" - "), unit: "cm" };
    return { text: v, unit: "cm" };
  }

  function rowsOf(t) {
    if (t.direction !== "row") return t.rows;
    var out = [];
    t.rows.forEach(function (row, r) {
      row.forEach(function (c, i) {
        (out[i] = out[i] || [])[r] = c;
      });
    });
    return out;
  }

  // Pants and jeans charts list every size once per leg length ("M Short",
  // "M Standard", "W32 / L34"). Shown as one row per size with a column per
  // length, so the chart is a third as long. null when the chart isn't
  // like that.
  var LENGTH_RE = /^(.*?)[\s\/]+(extra short|short|petite|standard|regular|long|tall|extra long|L\d{2}"?)$/i;
  var LENGTH_RANK = { "extra short": 0, short: 1, petite: 1, standard: 2, regular: 2, long: 3, tall: 3, "extra long": 4 };
  function splitLength(label) {
    var m = String(label == null ? "" : label).trim().match(LENGTH_RE);
    return m && m[1] ? { size: m[1].trim(), length: m[2].trim() } : null;
  }
  function lengthRank(len) {
    var l = len.toLowerCase().replace(/"/g, "");
    if (/^l\d{2}$/.test(l)) return 10 + parseInt(l.slice(1), 10);
    return LENGTH_RANK[l] != null ? LENGTH_RANK[l] : 5;
  }
  function lengthLabel(len) {
    return /^l\d/i.test(len) ? len.toUpperCase() : len.charAt(0).toUpperCase() + len.slice(1).toLowerCase();
  }
  var LEG_RE = /\b(inseam|inside leg|leg length|leg)\b/i;
  function pivotHtml(t, units, highlight) {
    var rows = rowsOf(t);
    if (rows.length < 4) return null;
    var head = rows[0];
    var body = rows.slice(1);
    var parts = body.map(function (r) { return splitLength(r[0] && r[0].v); });
    if (parts.some(function (x) { return !x; })) return null;
    var groups = [];
    var byKey = {};
    parts.forEach(function (x, i) {
      var k = norm(x.size);
      if (!byKey[k]) groups.push((byKey[k] = { size: x.size, rows: [] }));
      byKey[k].rows.push({ row: body[i], length: x.length, index: i });
    });
    if (groups.length === body.length) return null;
    // Columns the same for every length of a size (hips) stay as they are;
    // the one that changes with the length (inseam) fills the length columns.
    var fixed = [];
    var varying = [];
    for (var c = 1; c < head.length; c++) {
      var same = groups.every(function (g) {
        return g.rows.every(function (r) { return norm(r.row[c] && r.row[c].v) === norm(g.rows[0].row[c] && g.rows[0].row[c].v); });
      });
      (same ? fixed : varying).push(c);
    }
    if (varying.length !== 1) return null;
    var vc = varying[0];
    var lengths = [];
    parts.forEach(function (x) {
      if (!lengths.some(function (l) { return norm(l) === norm(x.length); })) lengths.push(x.length);
    });
    lengths.sort(function (a, b) { return lengthRank(a) - lengthRank(b); });
    // What to highlight: a row index (calculator table) or a size label.
    var mark = highlight || {};
    var hit = null;
    if (typeof mark.index === "number" && body[mark.index]) hit = parts[mark.index];
    else if (mark.size != null) hit = splitLength(mark.size) || { size: String(mark.size), length: null };
    function cellTd(cell, cls) {
      if (!cell || cell.v == null || cell.v === "") return '<td class="pmo-sg__na' + (cls ? " " + cls : "") + '">&ndash;</td>';
      var s = showValue(cell, units);
      return "<td" + (cls ? ' class="' + cls + '"' : "") + ">" + esc(s.text) + (s.unit && s.text ? ' <span class="pmo-sg__note">' + s.unit + "</span>" : "") + "</td>";
    }
    var html = t.title ? '<h3 class="pmo-sg__table-title">' + esc(t.title) + "</h3>" : "";
    html += '<div class="pmo-sg__scroll"><table class="pmo-sg__pivot"><thead><tr><th>' + esc(head[0].v) + "</th>";
    fixed.forEach(function (c) { html += "<th>" + esc(head[c].v) + "</th>"; });
    lengths.forEach(function (l) { html += "<th>" + esc(lengthLabel(l)) + '<small>' + esc(String(head[vc].v || "").toLowerCase()) + "</small></th>"; });
    html += "</tr></thead><tbody>";
    groups.forEach(function (g) {
      var rowHit = hit && norm(hit.size) === norm(g.size);
      html += "<tr" + rowClass(mark, rowHit, g.size) + "><th>" + esc(g.size) + "</th>";
      fixed.forEach(function (c) {
        var cell = g.rows[0].row[c];
        html += cell && cell.h ? "<th>" + esc(cell.v) + "</th>" : cellTd(cell);
      });
      lengths.forEach(function (l) {
        var r = g.rows.filter(function (x) { return norm(x.length) === norm(l); })[0];
        if (!r) { html += '<td class="pmo-sg__na">&ndash;</td>'; return; }
        var on = rowHit && hit.length && norm(hit.length) === norm(l);
        html += cellTd(r.row[vc], on ? "is-pick" : "");
      });
      html += "</tr>";
    });
    return html + "</tbody></table></div>";
  }

  // highlight: the calculator table's row index, or the size label to find
  // in the first column of any other table.
  // The recommended size's row: green when every measurement sits in that
  // one size, terracotta when they span sizes (the other sizes they touch
  // get a lighter terracotta).
  function baseSize(label) {
    var x = splitLength(label);
    return norm(x ? x.size : label);
  }
  // True when every column of table t is in the size-by-length table full,
  // and its rows are either leg lengths or sizes whose numbers all appear
  // there too.
  function coveredBy(t, full) {
    if (!t || !full) return false;
    var rows = rowsOf(t);
    var fullRows = rowsOf(full);
    if (rows.length < 2 || !fullRows.length) return false;
    var heads = fullRows[0].map(function (c) { return norm(c && c.v); });
    var cols = rows[0].slice(1).map(function (c) { return heads.indexOf(norm(c && c.v)); });
    if (!cols.length || cols.some(function (c) { return c < 1; })) return false;
    var body = rows.slice(1);
    if (body.every(function (r) { return LENGTH_RANK[norm(r[0] && r[0].v)] != null; })) return true;
    return body.every(function (r) {
      return cols.every(function (fc, k) {
        var v = norm(r[k + 1] && r[k + 1].v);
        return fullRows.slice(1).some(function (fr) { return norm(fr[fc] && fr[fc].v) === v; });
      });
    });
  }
  function rowClass(mark, isHit, label) {
    if (isHit) return ' class="is-match' + (mark.fit ? " is-fit" : "") + '"';
    if (mark.span && mark.span.indexOf(baseSize(label)) > -1) return ' class="is-span"';
    return "";
  }
  function tableHtml(t, units, highlight) {
    var pivot = pivotHtml(t, units, highlight);
    if (pivot) return pivot;
    var rows = rowsOf(t);
    if (!rows.length) return "";
    var head = rows[0];
    var body = rows.slice(1);
    var html = t.title ? '<h3 class="pmo-sg__table-title">' + esc(t.title) + "</h3>" : "";
    html += '<div class="pmo-sg__scroll"><table><thead><tr>';
    head.forEach(function (c) {
      html += "<th>" + esc(c.v) + "</th>";
    });
    html += "</tr></thead><tbody>";
    body.forEach(function (row, i) {
      var mark = highlight || {};
      var label = row[0] && row[0].v;
      var match = typeof mark.index === "number" ? mark.index === i : mark.size != null && (norm(label) === norm(mark.size) || norm(label) === baseSize(mark.size));
      html += "<tr" + rowClass(mark, match, label) + ">";
      row.forEach(function (c, ci) {
        if (c.h || ci === 0) {
          html += "<th>" + esc(c.v) + "</th>";
          return;
        }
        var s = showValue(c, units);
        html += "<td>" + esc(s.text) + (s.unit && s.text ? ' <span class="pmo-sg__note">' + s.unit + "</span>" : "") + "</td>";
      });
      html += "</tr>";
    });
    return html + "</tbody></table></div>";
  }

  // Where each measurement sits on the chart: the chart's sizes as one
  // continuous strip (the recommended size in green, a size either side in
  // grey) with a line at the rider's measurement. Same look as The Gear
  // Studio's "Where you sit".
  function cellBand(cell) {
    if (!cell) return null;
    var f = TO_CM[cell.u] || 1;
    var n = String(cell.v == null ? "" : cell.v).replace(/,/g, ".").split("-").map(function (x) { return parseFloat(x) * f; })
      .filter(function (x) { return isFinite(x); }).sort(function (a, b) { return a - b; });
    return n.length ? [n[0], n[n.length - 1]] : null;
  }
  function stripsHtml(calc, r, table, values, units) {
    if (calc.mode === "cover") return "";
    var rows = rowsOf(table);
    if (!rows || rows.length < 3 || !values || !values.length) return "";
    var scol = calc.size || 0;
    var green = [baseSize(r.size)].concat(r.span ? r.span.sizes : []);
    var show = function (cm) { return units === "in" ? round1(cm / 2.54) + "in" : round1(cm) + "cm"; };
    var range = function (b) { return b[0] <= 0 ? "up to " + show(b[1]) : b[0] === b[1] ? show(b[1]) : (units === "in" ? round1(b[0] / 2.54) + "–" + round1(b[1] / 2.54) + "in" : round1(b[0]) + "–" + round1(b[1]) + "cm"); };
    var html = '<div class="pmo-sg__strips" aria-label="Where you sit on the ' + esc(r.size) + ' chart">';
    calc.fields.forEach(function (f, i) {
      var v = Number(values[i]); if (!(v > 0)) return;
      var bands = rows.slice(1).map(function (row) { return cellBand(row[f.col]); });
      var segs = [];
      // A leg length on a chart whose rows are "EU 38 Short / Standard /
      // Long": the strip is the lengths, not the sizes again -- the sizes
      // already have their own strip above it.
      var lens = LEG_RE.test(f.label) ? rows.slice(1).map(function (row) { return splitLength(row[scol] && row[scol].v); }) : null;
      if (lens && lens.every(function (x) { return x; })) {
        var mine = splitLength(r.size), byLen = {};
        lens.forEach(function (x, k) {
          var b = bands[k]; if (!b) return;
          var g = byLen[x.length] || (byLen[x.length] = { lo: b[0], hi: b[1], raw: [b[0], b[1]], sz: x.length, lab: x.length, sug: false });
          g.lo = Math.min(g.lo, b[0]); g.hi = Math.max(g.hi, b[1]); g.raw = [g.lo, g.hi];
          if (mine && norm(mine.length) === norm(x.length)) g.sug = true;
        });
        segs = Object.keys(byLen).map(function (k) { return byLen[k]; }).sort(function (a, b) { return a.lo - b.lo; });
      } else rows.slice(1).forEach(function (row, k) {
        var b = bands[k]; if (!b) return;
        var lab = String(row[scol] && row[scol].v != null ? row[scol].v : "").trim(), x = splitLength(lab), sz = x ? x.size : lab;
        var lo = b[0], hi = b[1];
        if (lo === hi) {
          var prev = bands[k - 1], next = bands[k + 1];
          lo = prev ? (prev[1] + b[0]) / 2 : null; hi = next ? (b[1] + next[0]) / 2 : null;
          var step = hi != null ? hi - b[1] : lo != null ? b[0] - lo : 2;
          if (lo == null) lo = b[0] - step; if (hi == null) hi = b[1] + step;
        } else if (lo <= 0) {
          var nx = bands[k + 1]; lo = nx && nx[1] > nx[0] ? b[1] - (nx[1] - nx[0]) : b[1] - 4;
        }
        var last = segs[segs.length - 1], on = green.indexOf(baseSize(lab)) > -1;
        if (last && last.raw[0] === b[0] && last.raw[1] === b[1]) { if (on) last.sug = true; return; }
        if (last && last.sz === sz) { last.hi = Math.max(last.hi, hi); last.raw = [Math.min(last.raw[0], b[0]), Math.max(last.raw[1], b[1])]; if (on) last.sug = true; return; }
        segs.push({ lo: lo, hi: hi, raw: b, sz: sz, lab: lab, sug: on });
      });
      if (segs.length < 2) return;
      // Sizes meet: gaps (83-86, 87-90) and overlaps (88-92, 90-94) split
      // down the middle, so the strip is continuous.
      for (var q = 1; q < segs.length; q++) {
        var a = segs[q - 1], c = segs[q];
        if (c.lo !== a.hi && c.lo > a.lo && c.hi > a.hi) { var mid = (a.hi + c.lo) / 2; a.hi = mid; c.lo = mid; }
      }
      var si = [], vi = 0, best = Infinity;
      segs.forEach(function (x, k) {
        if (x.sug) si.push(k);
        var d = v < x.lo ? x.lo - v : v > x.hi ? v - x.hi : 0; if (d < best) { best = d; vi = k; }
      });
      var from = Math.max(0, Math.min.apply(null, si.concat([vi])) - 1), to = Math.min(segs.length - 1, Math.max.apply(null, si.concat([vi])) + 1);
      var win = segs.slice(from, to + 1);
      var lo0 = Math.min(win[0].lo, v), hi0 = Math.max(win[win.length - 1].hi, v), pad = (hi0 - lo0) * 0.06 + 0.5, l = lo0 - pad, w = hi0 + pad - l;
      var inSug = win.some(function (x) { return x.sug && v >= x.lo && v <= x.hi; });
      var sugs = win.filter(function (x) { return x.sug; });
      var full = sugs.map(function (x) { return x.sz + " " + range(x.raw); }).join(" · "), right = full;
      if (sugs.length > 1) {
        var fs = sugs[0], zs = sugs[sugs.length - 1], fl = fs.sz.split(" / ")[0], zl = zs.sz.split(" / ")[0], pre = (fl.match(/^[^\d]*\s/) || [""])[0];
        if (pre && zl.indexOf(pre) === 0) zl = zl.slice(pre.length);
        right = win.indexOf(zs) - win.indexOf(fs) === sugs.length - 1 ? fl + "–" + zl + " " + range([fs.raw[0], zs.raw[1]]) : sugs.map(function (x) { return x.sz.split(" / ")[0]; }).join(" & ");
      }
      html += '<div class="pmo-sg__strip-row"><div class="pmo-sg__strip-head"><strong>' + esc(String(f.label).replace(/ circumference/i, "")) + " " + show(v) + '</strong><span title="' + esc(full) + '">' + esc(right) + "</span></div>" +
        '<div class="pmo-sg__strip">' + win.map(function (x) {
          var left = (x.lo - l) / w * 100, width = (x.hi - x.lo) / w * 100, s1 = x.sz.split(" / ")[0], s2 = s1.replace(/^[A-Za-z]+\s+(?=\d)/, "");
          return '<i class="pmo-sg__step' + (x.sug ? " is-sug" : "") + '" style="left:' + left.toFixed(2) + "%;width:" + width.toFixed(2) + '%" title="' + esc(x.sz + " " + range(x.raw)) + '"><b data-full="' + esc(x.sz) + '" data-s1="' + esc(s1) + '" data-s2="' + esc(s2) + '">' + esc(x.sz) + "</b></i>";
        }).join("") +
        '<i class="pmo-sg__pin' + (inSug ? "" : " is-out") + '" style="left:' + ((v - l) / w * 100).toFixed(2) + '%"></i></div></div>';
    });
    return html + "</div>";
  }
  // A size name that doesn't fit its piece of the strip shortens:
  // "XL / AU 16" to "XL", then "EU 42" to "42".
  function fitStrips(root) {
    if (!root) return;
    var bs = root.querySelectorAll(".pmo-sg__step b[data-full]");
    for (var i = 0; i < bs.length; i++) {
      var b = bs[i], room = b.parentNode.clientWidth - 2;
      if (!room) continue;
      b.textContent = b.getAttribute("data-full");
      if (b.offsetWidth > room) b.textContent = b.getAttribute("data-s1");
      if (b.offsetWidth > room) b.textContent = b.getAttribute("data-s2");
    }
  }
  window.addEventListener("resize", function () {
    Array.prototype.forEach.call(document.querySelectorAll("pmo-size-guide"), fitStrips);
  });

  // How to take each measurement, from the "How to measure" page. Picked
  // by the field's name; anything unrecognised gets the general advice.
  var GUIDE_URL = "https://peakmotogear.com.au/pages/how-to-take-measurements-for-motorcycle-gear";
  var TIPS = [
    [/bust|chest/, "Bust / chest", "Measure around the widest part of your chest, keeping the tape level around your back. Some brands ask for your arms down by your side."],
    [/waist/, "Waist", "Measure around your waist at the point where you bend side to side."],
    [/hip|seat/, "Hips", "Stand with your feet together and measure around the widest part of your bum."],
    [/thigh/, "Mid-thigh", "Use your dominant leg with that foot up on a stool. Measure around the midpoint between your hip crease and your knee. This usually isn't the widest point."],
    [/inseam|inside leg|leg length/, "Inseam", "Measure from your groin down to your ankle bone, following along the inside of your leg."],
    [/head/, "Head", "Measure around your forehead and behind the bony bump at the back of your head (the occipital bone).", "Keep the tape snug but not tight."],
    [/hand length|hand size/, "Hand length", "Measure from where the palm joins the forearm to the tip of the middle finger.", ""],
    [/palm|hand|knuckle/, "Palm", "With your hand softly closed, measure around your knuckles and across your palm.", "Keep the tape snug but not tight."],
    [/foot|feet/, "Foot length", "Stand with your heel against a wall and measure from the wall to the tip of your longest toe. Use your longer foot.", ""],
    [/height/, "Height", "Stand straight against a wall without shoes and measure from the floor to the top of your head.", ""]
  ];
  // A tip's fourth entry replaces this for measurements it doesn't suit
  // (hands, feet, head, height); empty means nothing is added.
  var TIP_GENERAL = "Measure over light clothing, roughly what you'd wear under your gear. Stand relaxed, breathe out normally and keep the tape snug but not tight.";

  // own: the chart's own instruction for this measurement, when it has one.
  function tipHtml(label, own) {
    if (own) return "<strong>How to measure your " + esc(areaName(label)) + ":</strong> " + esc(own);
    if (isGarment(label)) {
      var area = esc(areaName(label).replace(/ of (a )?\w+$/, ""));
      if (/\bflat\b|width|armpit/i.test(label)) {
        return "<strong>How to measure:</strong> lay a piece you own that fits you well flat, done up, and measure the " + area + " straight across from edge to edge.";
      }
      return "<strong>How to measure:</strong> measure around the " + area + " of a jacket you own that fits you well, done up.";
    }
    var tip = null;
    var l = norm(label);
    TIPS.forEach(function (t) {
      if (!tip && t[0].test(l)) tip = t;
    });
    var html = tip ? "<strong>How to measure your " + esc(tip[1].toLowerCase()) + ":</strong> " + esc(tip[2]) : "";
    var general = tip && tip[3] != null ? tip[3] : TIP_GENERAL;
    return html + (general ? (html ? " " : "") + '<span class="pmo-sg__tip-general">' + esc(general) + "</span>" : "");
  }

  // The chart's own "how to measure" lines, matched to its calculator
  // fields. A line used in the tip comes out of the guide text below the
  // charts so it isn't said twice. Hand length comes before palm/hand.
  var AREAS = [
    ["hand length", /^(hand length|hand size)/],
    ["palm", /^(palm|hand circumference|hand girth|hand)/],
    ["chest", /^(chest|bust)/],
    ["waist", /^waist/],
    ["hips", /^(hips?|seat)/],
    ["thigh", /^(mid[- ]?thigh|thigh)/],
    ["inseam", /^(inseam|inside leg|leg length)/],
    ["head", /^head/],
    ["foot", /^(foot|feet)/],
    ["height", /^height/]
  ];

  function areaKey(text) {
    var t = String(text || "").toLowerCase().trim();
    for (var i = 0; i < AREAS.length; i++) if (AREAS[i][1].test(t)) return AREAS[i][0];
    return null;
  }

  // The rider's measurements are shared with the collection pages (the
  // same browser storage as assets/pmo-fit.js), so measurements typed in one
  // place fill the boxes in the other. Only body measurements are shared,
  // never a garment's own.
  var RIDER_KEY = "pmo.rider.v1";
  function riderKey(label) {
    if (isGarment(label)) return null;
    var parts = areaName(label).split(/\s*\/\s*/);
    for (var i = 0; i < parts.length; i++) {
      var k = areaKey(parts[i].replace(/^(full|natural|lower|upper|true|body)\s+/, ""));
      if (k) return k;
    }
    return null;
  }
  function loadRider() {
    try {
      var p = JSON.parse(localStorage.getItem(RIDER_KEY) || "null");
      return p && typeof p === "object" ? p : {};
    } catch (e) {
      return {};
    }
  }
  function saveRider(meas) {
    try {
      var p = loadRider();
      p.meas = Object.assign({}, p.meas || {}, meas);
      p.at = Date.now();
      localStorage.setItem(RIDER_KEY, JSON.stringify(p));
    } catch (e) {}
  }
  function riderValue(v) {
    var n = parseFloat(v);
    return isFinite(n) && n >= 5 && n <= 250 ? n : null;
  }
  // Calculators the rider's measurements apply to: body charts only, not
  // bike covers or garment-measurement charts.
  function sharesRider(chart) {
    return !!(chart && chart.calc && chart.calc.mode !== "cover" && !chart.garment);
  }

  // What a calculator field is called for matching guide lines: a known
  // body area when there is one, otherwise its own name ("t-shirt width").
  // "Full Bust / Chest" is the chest: each part of a label is tried, without
  // words like "full" or "natural" in front.
  function fieldKey(label) {
    var name = areaName(label);
    var key = areaKey(name);
    if (key) return key;
    var parts = name.split(/\s*\/\s*/);
    for (var i = 0; i < parts.length; i++) {
      key = areaKey(parts[i].replace(/^(full|natural|lower|upper|true|body)\s+/, ""));
      if (key) return key;
    }
    return name;
  }

  function fieldFor(text, wanted) {
    var t = String(text || "").toLowerCase().trim();
    var key = areaKey(t);
    for (var i = 0; i < wanted.length; i++) {
      var w = wanted[i];
      if ((key && key === w.key) || w.names.some(function (n) { return n && t.indexOf(n) === 0; })) return w;
    }
    return null;
  }

  function capital(s) {
    s = String(s || "").trim();
    return s.charAt(0).toUpperCase() + s.slice(1);
  }

  // Reads one block of guide HTML. Returns { found: {area: text}, html }.
  function pullHowTo(html, wanted) {
    var found = {};
    if (!html || !wanted.length || typeof DOMParser === "undefined") return { found: found, html: html };
    var doc = new DOMParser().parseFromString("<div>" + html + "</div>", "text/html");
    var root = doc.body.firstChild;
    // Lines: each block element, split further at <br>.
    var lines = [];
    root.querySelectorAll("p, li, h1, h2, h3, h4, h5, h6, div").forEach(function (el) {
      if (el.querySelector("p, li, div, h1, h2, h3, h4, h5, h6")) return;
      var parts = el.innerHTML.split(/<br\s*\/?>/i);
      parts.forEach(function (part, i) {
        var tmp = doc.createElement("div");
        tmp.innerHTML = part;
        lines.push({ el: el, part: i, parts: parts, text: tmp.textContent.replace(/\s+/g, " ").trim() });
      });
    });
    var drop = [];
    lines.forEach(function (line, i) {
      var t = line.text.replace(/^(\d+|[A-Z])\s*[-–:.)]\s+/, "").replace(/^[•·*-]\s*/, "");
      var w = fieldFor(t, wanted);
      if (!w || found[w.key]) return;
      var key = w.key;
      // "Name: how" or "Name - how" (a dash needs spaces, so "T-Shirt" stays whole).
      var m = t.match(/^([^:]{2,60}?)\s*(\([^)]*\))?\s*:\s*(.+)$/) || t.match(/^(.{2,60}?)\s*(\([^)]*\))?\s+[-–]\s+(.+)$/);
      if (m && fieldFor(m[1], wanted) === w && m[3].length > 8) {
        found[key] = capital(m[3]);
        drop.push(line);
        return;
      }
      // A heading on its own line, with the instruction on the next.
      var bare = t.replace(/\([^)]*\)/g, "").replace(/[:\s]+$/, "").trim();
      var next = lines[i + 1];
      if (fieldFor(bare, wanted) === w && bare.split(" ").length <= 3 && next && next.text.length > 8 && !fieldFor(next.text, wanted)) {
        found[key] = capital(next.text);
        drop.push(line, next);
      }
    });
    if (!drop.length) return { found: found, html: html };
    drop.forEach(function (line) {
      line.parts[line.part] = null;
    });
    lines.forEach(function (line) {
      if (line.done) return;
      var kept = line.parts.filter(function (x) { return x !== null; });
      line.el.innerHTML = kept.join("<br>");
      lines.forEach(function (l) { if (l.el === line.el) l.done = true; });
    });
    root.querySelectorAll("p, li, h1, h2, h3, h4, h5, h6").forEach(function (el) {
      if (!el.textContent.trim() && !el.querySelector("img")) el.remove();
    });
    var left = root.textContent.replace(/\s+/g, " ").trim();
    if ((!left || /^how to measure:?$/i.test(left)) && !root.querySelector("img")) return { found: found, html: "" };
    return { found: found, html: root.innerHTML };
  }

  function prepareHowTo(chart) {
    chart.howto = {};
    if (!chart.calc) return;
    var wanted = chart.calc.fields.map(function (f) {
      return { key: fieldKey(f.label), names: [norm(f.label), areaName(f.label)] };
    });
    (chart.blocks || []).forEach(function (b) {
      if (b.k === "html") {
        var out = pullHowTo(b.html, wanted);
        Object.keys(out.found).forEach(function (k) { if (!chart.howto[k]) chart.howto[k] = out.found[k]; });
        b.html = out.html;
      } else if (b.k === "fig") {
        (b.items || []).forEach(function (it) {
          var o = pullHowTo(it.html, wanted);
          Object.keys(o.found).forEach(function (k) { if (!chart.howto[k]) chart.howto[k] = o.found[k]; });
          it.html = o.html;
        });
      }
    });
  }

  // The figures beside the size finder, traced from plain outlines.
  var BODY_PATH = "M67.7 0.3C65.5 0.7 63.1 1.9 61.5 3.4C60 4.9 59.1 7.3 58.4 9.5C57.7 11.6 57.8 14.1 57.4 16.3C57 18.5 55.8 20.7 56.1 22.8C56.4 24.9 58.5 26.8 59.3 29C60.2 31.1 61.3 33.4 61.3 35.6C61.3 37.7 60.9 40.5 59.5 42C58.2 43.5 55.2 43.9 53 44.5C50.8 45.1 48.4 45.2 46.2 45.7C44 46.3 41.5 46.6 39.8 48C38.2 49.3 37.1 51.7 36.3 53.9C35.5 56 35.4 58.4 35 60.6C34.6 62.9 34.2 65.2 33.8 67.5C33.5 69.8 33.4 72.1 32.9 74.3C32.5 76.6 31.8 78.8 31.2 81.1C30.6 83.3 30 85.5 29.3 87.8C28.6 90 27.9 92.2 27.1 94.4C26.2 96.6 25.2 98.6 24.3 100.8C23.5 103 22.6 105.1 22 107.3C21.3 109.6 21 111.8 20.5 114.1C20 116.4 19.6 118.6 19.2 120.9C18.8 123.2 18.6 125.5 18.1 127.7C17.5 130 17.1 132.5 15.9 134.4C14.7 136.2 12.5 137.3 10.7 138.9C9 140.4 7.3 142 5.6 143.5C3.8 145.1 0.2 147.5 0.3 148.1C0.4 148.7 5 146.5 6.2 147.3C7.3 148.1 7.3 150.9 7.2 153C7.1 155.1 5.3 157.9 5.6 159.8C5.8 161.7 7.2 163.6 8.7 164.4C10.2 165.1 12.8 164.9 14.5 164.1C16.2 163.3 17.7 161.4 18.8 159.5C19.8 157.7 20.3 155.1 21 152.9C21.7 150.7 22.5 148.4 22.9 146.2C23.2 144 22.5 141.7 23 139.5C23.5 137.4 25 135.3 26 133.2C27 131.2 28.1 129.1 29.1 127C30.1 124.9 31.1 122.8 32 120.7C33 118.6 33.9 116.5 34.8 114.3C35.6 112.2 36.4 109.9 37 107.7C37.6 105.4 37.8 103.1 38.3 100.9C38.8 98.6 39.3 96.4 40 94.2C40.6 91.9 41.4 89.3 42.4 87.6C43.4 85.9 45 83.5 45.9 84C46.8 84.5 47.2 88.4 47.6 90.7C48 92.9 48.2 95.3 48.5 97.5C48.8 99.8 49.4 102.1 49.4 104.4C49.4 106.7 49.1 109 48.6 111.3C48 113.5 46.9 115.6 46.1 117.8C45.3 120 44.6 122.1 43.9 124.4C43.2 126.6 42.5 128.8 42.1 131.1C41.6 133.3 41.5 135.6 41.2 137.9C40.9 140.2 40.5 142.5 40.2 144.8C39.9 147.1 39.4 149.3 39.3 151.6C39.2 153.9 39.5 156.3 39.8 158.6C40 160.9 40.4 163.1 40.8 165.4C41.2 167.7 41.7 170 42.1 172.2C42.5 174.5 42.8 176.8 43.2 179C43.7 181.3 44.4 183.5 44.8 185.8C45.3 188.1 45.5 190.4 45.9 192.6C46.4 194.9 47.1 197.1 47.6 199.4C48 201.6 48.1 203.9 48.5 206.2C48.8 208.5 49.4 210.8 49.7 213C49.9 215.3 50.1 217.6 49.9 219.9C49.7 222.1 48.8 224.4 48.5 226.7C48.3 229 48.5 231.3 48.5 233.7C48.5 236 48.3 238.4 48.5 240.7C48.6 243 49.1 245.2 49.4 247.5C49.7 249.8 49.9 252.1 50.3 254.4C50.7 256.7 51.2 258.9 51.7 261.2C52.1 263.4 52.6 265.7 53 268C53.5 270.2 54.2 272.4 54.7 274.7C55.1 277 55.6 279.2 55.7 281.5C55.9 283.8 56.1 286.3 55.7 288.5C55.2 290.7 53 293.2 53.1 295C53.1 296.7 54.3 298.4 55.9 299.1C57.5 299.8 61.1 299.9 62.7 299.1C64.4 298.3 65.5 296.1 66 294.2C66.6 292.2 66 289.5 65.9 287.2C65.7 284.9 65.2 282.6 65.1 280.3C64.9 278 64.8 275.6 64.9 273.3C65.1 271 65.6 268.7 65.8 266.4C65.9 264.1 65.7 261.8 65.9 259.4C66 257.1 66.5 254.9 66.8 252.6C67.1 250.3 67.5 248 67.7 245.7C67.8 243.4 67.8 241 67.7 238.7C67.5 236.4 67.1 234.1 66.8 231.9C66.5 229.6 65.9 227.3 65.9 225C65.8 222.7 66.3 220.4 66.6 218.1C66.9 215.8 67.5 213.6 67.7 211.3C67.9 209 67.7 206.6 67.7 204.3C67.7 201.9 67.7 199.6 67.7 197.3C67.7 194.9 67.8 192.6 67.7 190.3C67.5 188 66.8 185.7 66.8 183.4C66.7 181.1 67.2 178.8 67.4 176.5C67.6 174.2 67.9 171.9 68.2 169.6C68.4 167.3 68.4 163.2 69 162.7C69.5 162.3 70.8 165.3 71.3 167.2C71.9 169.1 72 171.8 72.3 174.1C72.6 176.3 73.2 178.6 73.2 180.9C73.2 183.2 72.4 185.5 72.3 187.8C72.1 190.1 72.3 192.5 72.3 194.8C72.3 197.1 72.3 199.5 72.3 201.8C72.3 204.1 72.1 206.5 72.3 208.8C72.4 211.1 72.8 213.4 73.1 215.7C73.4 218 74 220.2 74.1 222.5C74.2 224.8 73.8 227.1 73.5 229.4C73.3 231.7 72.7 234 72.5 236.3C72.3 238.6 72.1 240.9 72.3 243.2C72.4 245.6 72.9 247.8 73.2 250.1C73.5 252.4 73.9 254.7 74.1 257C74.2 259.3 73.9 261.7 74.1 264C74.2 266.3 74.8 268.5 75 270.8C75.2 273.1 75.2 275.5 75 277.8C74.8 280.2 74.2 282.4 74.1 284.7C73.9 287 74 289.4 74.1 291.7C74.2 294 73.6 297.2 74.9 298.3C76.1 299.5 79.5 298.7 81.6 298.5C83.8 298.4 87.2 298.5 87.8 297.3C88.4 296 85.7 293.1 85.1 290.9C84.5 288.7 84.1 286.3 84.1 284C84.1 281.7 84.7 279.4 85.1 277.1C85.4 274.9 85.7 272.6 86.1 270.3C86.6 268 87.3 265.8 87.8 263.6C88.3 261.3 88.6 259 89.1 256.8C89.6 254.5 90.2 252.3 90.5 250C90.9 247.7 91.3 245.5 91.5 243.1C91.6 240.8 91.5 238.5 91.5 236.1C91.5 233.8 91.6 231.4 91.5 229.1C91.3 226.8 90.9 224.6 90.5 222.3C90.2 220 89.6 217.7 89.6 215.4C89.7 213.1 90.4 210.9 90.8 208.6C91.3 206.3 91.8 204.1 92.2 201.8C92.6 199.5 92.8 197.2 93.3 195C93.7 192.7 94.4 190.5 94.9 188.2C95.3 186 95.6 183.7 96 181.4C96.5 179.2 97.1 176.9 97.6 174.7C98 172.4 98.4 170.1 98.8 167.8C99.1 165.6 99.4 163.3 99.7 161C100 158.7 100.6 156.4 100.6 154.1C100.7 151.8 100.2 149.5 100 147.2C99.8 144.9 99.8 142.6 99.5 140.3C99.2 138 98.6 135.8 98.2 133.5C97.7 131.2 97.4 128.9 96.8 126.7C96.2 124.5 95.4 122.3 94.6 120.1C93.9 118 92.9 115.8 92.2 113.6C91.5 111.4 90.7 109.1 90.5 106.9C90.4 104.6 91.3 102.3 91.5 100C91.6 97.7 91.3 95.3 91.6 93C91.8 90.7 92.3 87.6 93.2 86.3C94.1 85 95.8 84.3 96.7 85.3C97.7 86.2 98.2 89.7 98.9 91.9C99.7 94.1 100.5 96.3 101.1 98.5C101.7 100.7 101.9 103 102.4 105.3C103 107.5 103.7 109.8 104.4 112C105.1 114.2 106 116.4 106.9 118.5C107.8 120.6 108.7 122.7 109.7 124.8C110.7 126.9 111.9 128.9 112.9 131C113.9 133.1 115.1 135.1 115.9 137.3C116.7 139.4 117.2 141.6 117.6 143.8C118 146 117.7 148.3 118.2 150.5C118.6 152.8 119.4 155.2 120.4 157.2C121.3 159.2 122.5 161.2 123.9 162.5C125.4 163.8 127.5 165.2 129.2 165C131 164.9 133.8 163.4 134.5 161.7C135.1 160.1 133.7 157.2 133.3 154.9C132.9 152.6 131.2 149.1 132 148.1C132.9 147.2 137.7 149.7 138.4 149.1C139.1 148.5 137.3 146.2 136 144.7C134.8 143.1 132.7 141.4 130.8 140C129 138.6 126.5 137.8 125.1 136C123.8 134.3 123.2 131.8 122.5 129.6C121.7 127.4 121.2 125.2 120.7 122.9C120.3 120.6 120.2 118.3 119.8 116C119.4 113.8 118.9 111.5 118.4 109.3C117.9 107 117.6 104.6 116.8 102.5C116 100.4 114.3 98.6 113.4 96.4C112.5 94.3 112 92 111.3 89.8C110.7 87.6 110.1 85.3 109.4 83.1C108.8 80.9 108 78.7 107.5 76.4C106.9 74.2 106.5 71.9 106.1 69.6C105.7 67.4 105.5 65.1 105.2 62.8C104.9 60.5 104.9 58.1 104.3 55.9C103.7 53.7 103 51.2 101.6 49.5C100.2 47.8 98 46.4 95.9 45.7C93.8 45 91.2 45.6 89 45.2C86.7 44.8 84 44.5 82.3 43.3C80.6 42 79.1 39.9 78.7 37.8C78.3 35.8 79.2 33.3 79.9 31.1C80.6 28.9 82.2 27 82.9 24.8C83.5 22.7 83.9 20.4 83.8 18.2C83.7 16 82.9 13.8 82.2 11.6C81.6 9.4 81.2 6.9 79.9 5.1C78.6 3.3 76.5 1.7 74.5 0.9C72.4 0.1 69.8-0.1 67.7 0.3Z";
  // A small unlabelled figure beside the measurement boxes: the body, a
  // head, a hand or a foot. Bands for measurements this chart doesn't ask
  // for are greyed out, and the one being typed in turns terracotta (see
  // .pmo-sg__mini CSS).
  var FIG_STYLE = 'fill="#eef1f5" stroke="#3a506b" stroke-width="2" stroke-linejoin="round" stroke-linecap="round"';
  var FIGURES = {
    body: {
      width: 84,
      areas: ["chest", "waist", "hips", "inseam"],
      box: "-6 -4 153 308",
      shape: '<path ' + FIG_STYLE + ' d="' + BODY_PATH + '"/>',
      bands: {
        chest: '<ellipse cx="70" cy="92" rx="26" ry="4"/>',
        waist: '<ellipse cx="70" cy="118" rx="22" ry="3.5"/>',
        hips: '<ellipse cx="70" cy="152" rx="31" ry="4.5"/>',
        inseam: '<path d="M74 176L76 284" stroke-dasharray="4 4"/>'
      }
    },
    head: {
      width: 100,
      areas: ["head"],
      box: "-8 -8 136 166",
      shape: '<path ' + FIG_STYLE + ' d="M57 0.1C53.7 0.2 50.3 0.5 47 1.1C43.8 1.6 40.4 2.3 37.3 3.4C34.1 4.4 31 5.7 28.1 7.3C25.1 8.9 22.3 10.8 19.7 12.8C17.1 14.9 14.7 17.3 12.5 19.8C10.3 22.3 8.3 25.1 6.6 27.9C5 30.8 3.6 33.9 2.5 37.1C1.5 40.2 0.8 43.6 0.4 46.9C-0 50.2-0 53.5 0.1 56.9C0.3 60.2 0.7 63.6 1.4 66.8C2 70.1 2.9 73.4 4 76.5C5.2 79.6 6.7 82.7 8.4 85.5C10.1 88.4 12.3 90.9 14.3 93.6C16.3 96.3 18.8 98.7 20.4 101.6C21.9 104.5 23.1 107.8 23.6 111.0C24.1 114.3 23.6 117.7 23.2 121.0C22.7 124.3 21.9 127.6 21 130.8C20.2 134.1 18.8 137.4 18.2 140.5C17.7 143.5 16.2 147.7 17.8 149.2C19.3 150.7 24.4 149.5 27.8 149.5C31.1 149.6 34.5 149.5 37.8 149.5C41.2 149.5 44.5 149.5 47.9 149.5C51.2 149.5 54.6 149.5 57.9 149.5C61.3 149.5 64.6 149.5 67.9 149.5C71.3 149.5 76.3 151 78 149.7C79.7 148.3 78.3 144.4 78.3 141.3C78.2 138.3 77.2 134.5 77.6 131.3C78 128.2 78.7 124 80.8 122.2C83 120.3 87.2 120.6 90.5 120.2C93.8 119.9 97.4 120.7 100.6 120.2C103.7 119.8 108.1 119.4 109.7 117.3C111.2 115.1 109.3 110.5 109.8 107.4C110.3 104.2 112.3 101.5 112.7 98.5C113.1 95.5 111.4 91.9 112.4 89.4C113.4 86.8 117.7 85.7 118.7 83.3C119.7 80.8 119.4 77.5 118.5 74.7C117.5 71.9 114.5 69.2 112.8 66.4C111.1 63.5 108.7 60.6 108.3 57.5C107.8 54.4 109.8 51 110 47.7C110.2 44.4 110.1 40.9 109.4 37.7C108.7 34.5 107.3 31.3 105.9 28.3C104.5 25.3 102.7 22.4 100.7 19.7C98.8 17 96.6 14.4 94.2 12.2C91.7 9.9 88.9 7.9 86.1 6.3C83.2 4.6 80 3.3 76.9 2.3C73.7 1.3 70.4 0.7 67 0.3C63.7-0 60.4-0 57 0.1Z"/>',
      bands: { head: '<ellipse cx="56" cy="44" rx="58" ry="7" transform="rotate(-6 56 44)"/>' }
    },
    hand: {
      width: 112,
      areas: ["palm", "hand length"],
      box: "-8 -6 168 182",
      shape: '<path ' + FIG_STYLE + ' d="M53.9 1.3C52 2 50.3 5.4 49.5 7.8C48.6 10.2 49 13.1 48.8 15.8C48.5 18.5 48.2 21.2 48 23.8C47.9 26.5 48.1 29.2 48 31.9C47.9 34.6 47.4 37.2 47.3 39.9C47.1 42.6 47.2 45.3 47 48.0C46.8 50.6 46.5 53.3 46.3 56.0C46 58.7 46.1 61.4 45.7 64.0C45.3 66.6 44.9 71.3 43.9 71.7C43 72.2 40.6 68.7 39.8 66.5C38.9 64.4 39 61.2 38.6 58.6C38.2 55.9 37.8 53.3 37.5 50.6C37.1 47.9 36.8 45.3 36.5 42.6C36.2 40 35.9 37.3 35.6 34.6C35.4 31.9 35 29.3 34.8 26.6C34.6 23.9 35 21 34.3 18.6C33.5 16.1 32.2 12.6 30.4 11.8C28.6 11.1 24.9 12.5 23.4 14.2C21.8 15.8 21.5 19.2 21.2 21.8C20.8 24.4 21 27.2 21.1 29.8C21.3 32.5 21.6 35.2 21.9 37.9C22.1 40.5 22.3 43.2 22.6 45.9C22.9 48.6 23.3 51.2 23.6 53.9C23.9 56.6 24.1 59.2 24.3 61.9C24.5 64.6 24.9 67.3 25 69.9C25 72.6 25.6 76.6 24.7 78.0C23.8 79.3 20.7 79.4 19.6 78.1C18.5 76.8 18.4 72.9 17.9 70.2C17.4 67.6 17 64.9 16.6 62.3C16.1 59.6 15.8 57 15.2 54.3C14.6 51.7 14.2 48.9 13.1 46.6C12 44.2 10.4 41.1 8.4 40.2C6.4 39.3 2.7 39.5 1.3 41.0C-0 42.4 0.3 46.2 0.3 48.8C0.4 51.4 1.1 54.1 1.5 56.8C1.9 59.4 2.3 62.1 2.7 64.7C3.1 67.4 3.4 70 3.7 72.7C4 75.4 4.4 78 4.7 80.7C5 83.4 5.3 86 5.6 88.7C5.9 91.4 6.1 94 6.3 96.7C6.6 99.4 6.7 102.1 7 104.7C7.3 107.4 7.6 110.1 8 112.7C8.3 115.4 8.6 118.1 9.1 120.7C9.5 123.4 10 126 10.6 128.6C11.1 131.3 11.6 133.9 12.2 136.5C12.9 139.1 13.6 141.7 14.5 144.2C15.3 146.8 16.3 149.3 17.5 151.7C18.7 154.1 20.1 156.4 21.8 158.5C23.4 160.6 25.3 162.7 27.4 164.3C29.5 165.9 31.9 167.4 34.3 168.2C36.8 168.9 39.7 169 42.3 168.8C44.9 168.6 47.5 167.6 50.2 167.1C52.8 166.5 55.4 165.8 58.1 165.5C60.7 165.2 63.4 165.3 66.1 165.2C68.8 165.1 71.5 165.4 74.1 165.0C76.8 164.6 79.4 163.8 81.8 162.6C84.1 161.4 86.2 159.6 88.3 158.0C90.5 156.3 92.5 154.6 94.6 152.8C96.6 151.1 98.6 149.3 100.6 147.5C102.6 145.8 104.7 144.1 106.7 142.2C108.7 140.4 110.7 138.6 112.4 136.6C114.2 134.6 115.6 132.3 117.2 130.1C118.7 127.9 120.1 125.6 121.8 123.5C123.5 121.5 125.4 119.5 127.3 117.6C129.3 115.8 131.4 114.1 133.6 112.6C135.8 111.1 138.2 109.9 140.6 108.6C142.9 107.3 146 106.6 147.7 104.8C149.4 103 151.2 99.9 150.7 97.9C150.3 96 147 93.9 144.7 93.1C142.4 92.3 139.3 92.7 136.7 93.0C134.1 93.4 131.4 94.1 128.9 95.1C126.4 96 124.1 97.5 121.8 98.8C119.5 100.2 117.4 101.9 115.2 103.4C112.9 104.8 110.8 106.5 108.4 107.7C106 108.8 103.3 110.1 100.8 110.2C98.2 110.3 95.2 109.8 93.1 108.5C90.9 107.1 89.2 104.6 88.1 102.3C86.9 99.9 86.7 97.1 86.2 94.5C85.8 91.8 85.5 89.1 85.5 86.4C85.4 83.8 85.7 81.1 85.9 78.4C86.2 75.7 86.7 73.1 87.1 70.4C87.5 67.8 87.9 65.1 88.4 62.5C88.8 59.8 89.2 57.2 89.5 54.5C89.9 51.9 90.3 49.2 90.6 46.5C90.9 43.9 91.1 41.2 91.3 38.5C91.6 35.8 91.9 33.2 92.1 30.5C92.2 27.8 92.4 25.1 92.2 22.4C92.1 19.8 92.4 16.4 91.2 14.5C89.9 12.6 86.7 10.6 84.8 11.0C82.9 11.4 80.8 14.6 79.6 16.8C78.3 19.1 77.9 21.9 77.1 24.5C76.4 27.1 75.8 29.7 75.2 32.3C74.6 35 74.2 37.6 73.6 40.2C73.1 42.9 72.5 45.5 72 48.1C71.5 50.8 71 53.4 70.6 56.1C70.2 58.7 70 61.4 69.4 64.0C68.8 66.6 68.2 71 67 71.5C65.8 72.1 63.3 69.3 62.5 67.2C61.8 65.2 62.4 61.8 62.6 59.2C62.7 56.5 63.1 53.8 63.3 51.1C63.4 48.5 63.3 45.8 63.4 43.1C63.5 40.4 63.7 37.7 63.9 35.1C64 32.4 64.3 29.7 64.4 27.0C64.4 24.3 64.5 21.6 64.3 19.0C64.2 16.3 64.1 13.5 63.5 10.9C63 8.3 62.6 5 61 3.4C59.4 1.8 55.8 0.6 53.9 1.3Z"/>',
      bands: {
        palm: '<ellipse cx="48" cy="96" rx="44" ry="6"/>',
        "hand length": '<path d="M57 3L47 166" stroke-dasharray="4 4"/>'
      }
    },
    foot: {
      width: 58,
      areas: ["foot"],
      box: "-8 -6 108 182",
      shape: '<path ' + FIG_STYLE + ' d="M9.2 0.2C7.3 0.8 5.4 2 4.1 3.4C2.8 4.8 2 6.9 1.4 8.8C0.8 10.7 0.6 12.8 0.6 14.8C0.6 16.7 0.9 18.8 1.2 20.7C1.5 22.7 2 24.7 2.3 26.7C2.6 28.7 3 30.7 3.1 32.7C3.1 34.7 2.9 36.7 2.5 38.7C2.2 40.7 1.4 42.6 1 44.5C0.6 46.5 0.1 48.5 0 50.5C-0.1 52.5-0 54.5 0.2 56.5C0.4 58.5 0.8 60.5 1.2 62.5C1.7 64.4 2.1 66.4 2.7 68.3C3.2 70.3 3.8 72.2 4.4 74.1C5 76 5.6 77.9 6.1 79.9C6.7 81.8 7.1 83.8 7.5 85.8C7.9 87.8 8.2 89.8 8.4 91.7C8.7 93.7 8.9 95.7 9.2 97.7C9.4 99.7 9.6 101.7 9.8 103.7C10 105.7 10.3 107.7 10.4 109.7C10.5 111.7 10.4 113.8 10.4 115.8C10.4 117.8 10.5 119.8 10.4 121.8C10.3 123.8 10 125.8 9.8 127.8C9.6 129.8 9.4 131.8 9.2 133.8C9 135.8 8.7 137.8 8.6 139.8C8.5 141.8 8.5 143.9 8.6 145.9C8.7 147.9 8.8 149.9 9.2 151.9C9.6 153.8 10 155.9 10.8 157.7C11.7 159.5 12.9 161.2 14.2 162.7C15.5 164.1 17.2 165.4 18.9 166.4C20.6 167.4 22.6 168.2 24.5 168.7C26.4 169.2 28.5 169.4 30.5 169.4C32.5 169.4 34.5 169.1 36.4 168.6C38.4 168.1 40.3 167.4 42.1 166.5C43.9 165.6 45.6 164.5 47.1 163.2C48.6 161.9 50 160.3 51.1 158.6C52.2 157 53 155.1 53.7 153.2C54.3 151.3 54.8 149.3 55 147.3C55.3 145.3 55 143.3 55 141.3C55 139.2 55 137.2 55 135.2C55 133.2 54.9 131.2 55 129.2C55.1 127.1 55.4 125.1 55.6 123.2C55.9 121.2 56.3 119.2 56.7 117.2C57.1 115.2 57.6 113.3 58.1 111.3C58.6 109.4 59.1 107.4 59.5 105.5C60 103.5 60.4 101.5 60.8 99.6C61.2 97.6 61.5 95.6 61.9 93.6C62.2 91.6 62.6 89.6 62.9 87.7C63.3 85.7 63.6 83.7 64 81.7C64.5 79.7 65 77.8 65.6 75.9C66.3 74 67.1 72.1 67.8 70.2C68.5 68.3 69.3 66.5 69.7 64.5C70 62.5 69.9 60.4 69.7 58.4C69.5 56.5 68.7 54.6 68.3 52.6C67.8 50.7 67 48.7 66.7 46.8C66.4 44.8 66.6 42.8 66.7 40.8C66.7 38.8 67.3 36.7 67.3 34.8C67.2 32.8 67.3 30.1 66.3 28.9C65.2 27.7 62.5 26.9 61 27.5C59.6 28 58.1 30.5 57.6 32.3C57.1 34.1 58.6 37.3 58 38.3C57.4 39.2 54.3 39 54 38.0C53.6 37 55.2 34.2 55.8 32.3C56.4 30.4 57.4 28.5 57.5 26.6C57.5 24.7 57.3 22 56.1 20.8C55 19.6 52.1 19.4 50.7 19.1C49.2 18.8 48.2 20.1 47.6 19.2C47.1 18.2 48.3 14.8 47.3 13.5C46.4 12.1 43.6 11 42 11.3C40.3 11.6 38.5 13.5 37.6 15.1C36.7 16.7 36.9 19.1 36.7 21.0C36.4 23 36.7 26.3 36.1 27.0C35.6 27.8 33.9 26.6 33.6 25.3C33.4 24.1 34.2 21.4 34.6 19.4C35.1 17.4 36 15.5 36.1 13.6C36.2 11.6 36.2 9 35.2 7.7C34.1 6.3 31.5 5.3 29.9 5.5C28.2 5.7 26.2 7.3 25.2 8.8C24.2 10.3 24 12.6 23.8 14.6C23.7 16.6 24.4 18.6 24.5 20.6C24.5 22.6 25 25.5 24.3 26.5C23.6 27.5 20.9 27.4 20.3 26.4C19.8 25.4 20.6 22.5 21 20.5C21.4 18.5 22.3 16.7 22.6 14.7C22.9 12.7 23 10.5 22.6 8.6C22.2 6.7 21.6 4.6 20.3 3.2C19.1 1.8 17 0.7 15.2 0.2C13.3-0.3 11-0.3 9.2 0.2Z"/>',
      bands: { foot: '<path d="M86 0V170M80 0H92M80 170H92"/>' }
    }
  };

  // Which figure suits this chart's calculator, if any. Garment charts,
  // the bike cover and back-length measurements don't get one.
  function figureFor(calc) {
    if (!calc || calc.mode) return null;
    if (calc.fields.some(function (f) { return isGarment(f.label) || /shoulder/i.test(f.label || ""); })) return null;
    var keys = calc.fields.map(function (f) { return fieldKey(f.label); });
    var names = Object.keys(FIGURES);
    for (var i = 0; i < names.length; i++) {
      var fig = FIGURES[names[i]];
      if (keys.some(function (k) { return fig.areas.indexOf(k) >= 0; })) return { fig: fig, keys: keys };
    }
    return null;
  }

  function miniFigureHtml(found) {
    var fig = found.fig;
    var bands = Object.keys(fig.bands).map(function (a) {
      return fig.bands[a].replace(/^<(\w+)/, '<$1 class="pmo-sg__band' + (found.keys.indexOf(a) >= 0 ? "" : " is-off") + '" data-area="' + a + '"');
    }).join("");
    return '<div class="pmo-sg__mini" style="--w:' + fig.width + 'px" aria-hidden="true"><svg viewBox="' + fig.box + '">' + fig.shape +
      '<g fill="none" stroke-width="3">' + bands + "</g></svg></div>";
  }

  // Whatever the chart's own guide says beyond how to measure (fit advice,
  // which size to pick between two) is shown with the size finder, so
  // nothing sits below the charts. Measuring steps are left out here: the
  // tips and the figure cover those.
  var STEP_LINE = /^(how to measure|measure|position (the )?tape|exhale|using a (soft )?(measuring )?tape|place the|it should rest|take note|these are (the )?measurements of|lay a|lay it|wrap|stand|circumference|distance from|the (maximum|minimum|distance|tape|measurement|circumference)\b|take your|do not measure)/i;
  function chartNotes(chart) {
    var out = [];
    if (typeof DOMParser === "undefined") return out;
    var htmls = [];
    (chart.blocks || []).forEach(function (b) {
      if (b.k === "html" && b.html) htmls.push(b.html);
      if (b.k === "fig") (b.items || []).forEach(function (it) { if (it.html) htmls.push(it.html); });
    });
    htmls.forEach(function (html) {
      var doc = new DOMParser().parseFromString("<div>" + html + "</div>", "text/html");
      doc.querySelectorAll("img").forEach(function (im) { im.remove(); });
      var root = doc.body.firstChild;
      var lines = [];
      root.querySelectorAll("p, li, h1, h2, h3, h4, h5, h6, div").forEach(function (el) {
        if (el.querySelector("p, li, div, h1, h2, h3, h4, h5, h6")) return;
        el.innerHTML.split(/<br\s*\/?>/i).forEach(function (part) {
          var tmp = doc.createElement("div");
          tmp.innerHTML = part;
          lines.push(tmp.textContent.replace(/\s+/g, " ").trim());
        });
      });
      if (!lines.length) lines = [root.textContent.replace(/\s+/g, " ").trim()];
      lines.forEach(function (t) {
        var bare = t.replace(/^(\d+|[A-Z])\s*[-–:.)]\s+/, "").replace(/^[•·*-]\s*/, "");
        if (!bare || bare.length < 12 || STEP_LINE.test(bare) || /:$/.test(bare)) return;
        if (/^this chart lists body measurements/i.test(bare)) return;
        if (!/[.!?]/.test(bare) && bare.split(" ").length <= 4) return;
        var head = bare.split(/[:–-]|\s\(/)[0];
        if (areaKey(head) || /^(hand|palm|knuckle|finger|groin|crotch|inside leg|inseam|hip|chest|bust|waist|thigh|head|foot|feet|heel|sleeve|arm|back length|body (width|length)|length|width|bike length|t-shirt|neck|shoulder|waist to shoulder)\b/i.test(head)) return;
        if (out.indexOf(bare) < 0) out.push(bare);
      });
    });
    return out;
  }

  function notesHtml(chart) {
    if (!chart.notes || !chart.notes.length) return "";
    return '<div class="pmo-sg__notes">' + chart.notes.map(function (n) { return "<p>" + esc(n) + "</p>"; }).join("") + "</div>";
  }

  var CONSULT_URL = "https://peakmotogear.com.au/pages/fit-consultation";

  // When measurements point at different sizes, says which sizes they
  // span and why the recommended one was picked.
  function spanHtml(r) {
    var sp = r.span;
    if (!sp) return "";
    var list = sp.each.map(function (x) { return esc(areaName(x.label)) + " <strong>" + esc(x.size) + "</strong>"; }).join(", ");
    var mine = baseSize(r.size);
    var other = sp.each.filter(function (x) { return baseSize(x.size) !== mine; });
    var roomy = other.filter(function (x) { return !LEG_RE.test(x.label); }).map(function (x) { return esc(areaName(x.label)); });
    var long = other.some(function (x) { return LEG_RE.test(x.label); });
    var after = [];
    if (roomy.length) after.push("it may feel roomy in the " + roomy.join(" and "));
    if (long) after.push("the legs may be a little long");
    // What decided the size: a body measurement, the leg length, or both.
    var drivers = sp.each.filter(function (x) { return baseSize(x.size) === mine; });
    var byLeg = drivers.filter(function (x) { return LEG_RE.test(x.label); }).length;
    var why = !drivers.length || byLeg === 0 ? " so it isn't tight anywhere" : byLeg === drivers.length ? " so the legs are long enough" : " so it isn't tight anywhere and the legs are long enough";
    list = list.charAt(0).toUpperCase() + list.slice(1);
    var html = '<div class="pmo-sg__split"><strong>You sit between sizes ' + esc(sp.from) + " and " + esc(sp.to) + ".</strong> " + list + ". " +
      "We've recommended " + esc(splitLength(r.size) ? splitLength(r.size).size : r.size) + why + (after.length ? ", but " + after.join(" and ") : "") + ".";
    if (sp.wide) html += " Different brands and cuts suit different proportions, so if you're unsure, " +
      '<a href="' + CONSULT_URL + '" target="_blank" rel="noopener">book a free fit consultation</a> and we\'ll help you choose.';
    return html + "</div>";
  }

  function areaName(label) {
    var a = String(label || "").toLowerCase().replace(/\(.*?\)/g, "").replace(/\b(circumference|girth|measurement)\b/g, "").replace(/\s+/g, " ").trim();
    return a || String(label || "").toLowerCase();
  }

  // Charts that list the garment's own measurements (laid flat, or the
  // jacket's chest) rather than the body's: the calculator compares them
  // with a garment the shopper already owns.
  function isGarment(label) {
    if (/palm|hand|head|foot/i.test(label || "")) return false;
    return /\bflat\b|width|armpit|\bof (a )?(jacket|garment|hoodie|tee|shirt|pants|jeans)\b/i.test(label || "");
  }

  function norm(s) {
    return String(s || "").trim().toLowerCase();
  }

  // Body measurements are the norm, so only charts of the garment's own
  // measurements get a warning: "flat" when they're taken laid flat,
  // "garment" for other garment measurements, otherwise null. Sentences
  // saying a chart is NOT garment sizing don't count.
  var FLAT_RE = /\b(laid|lay|lying|layed|measured) flat\b|\bflat lay\b|\bflat\b.{0,30}\b(across|measure)|pit[- ]to[- ]pit|armpit to armpit|half chest/i;
  var GARMENT_RE = /\b(garment|product|jacket|clothing)('s)? (own )?measurements?\b|\bmeasurements? of the (garment|jacket|product)\b/i;
  function garmentKind(chart) {
    var bits = [];
    (chart.tables || []).forEach(function (t) {
      if (!t) return;
      bits.push(t.title || "");
      var rows = rowsOf(t);
      (rows[0] || []).forEach(function (c) { bits.push(c && c.v); });
    });
    var labels = bits.slice();
    if (chart.calc) chart.calc.fields.forEach(function (f) { labels.push(f.label); });
    (chart.blocks || []).forEach(function (b) {
      if (b.k === "html") bits.push(b.html);
      if (b.k === "fig") (b.items || []).forEach(function (it) { bits.push(it.html); });
    });
    var text = bits.map(function (x) { return String(x || "").replace(/<[^>]+>/g, " "); }).join(". ");
    var sentences = text.split(/[.!?]+\s|\n/).filter(function (x) { return !(/\bbody\b/i.test(x) && /\bnot\b/i.test(x)); });
    if (sentences.some(function (x) { return FLAT_RE.test(x); }) || labels.some(function (l) { return /\bflat\b/i.test(l || ""); })) return "flat";
    if (sentences.some(function (x) { return GARMENT_RE.test(x); }) || labels.some(function (l) { return l && isGarment(String(l)); })) return "garment";
    return null;
  }
  function garmentHtml(chart) {
    if (chart.garment === "flat") return '<div class="pmo-sg__warn"><strong>These are the garment\'s measurements, laid flat.</strong> They aren\'t body measurements. Lay a piece you own that fits you well flat, measure it the same way and compare.</div>';
    if (chart.garment === "garment") return '<div class="pmo-sg__warn"><strong>These are the garment\'s own measurements.</strong> They aren\'t body measurements. Measure a piece you own that fits you well and compare.</div>';
    return "";
  }

  // Finds the product's choices for the recommended size: "M" matches "M",
  // "M / AU 12" and "EU 40 / M". Pants with a separate length option ("M
  // Tall", "W32 / L34") get two: the size, and the length ("Tall 33\"",
  // "L34 (Standard Leg)"). Pipeline's option radios sit outside the cart
  // form (tied to it by a form attribute), and its dropdown-style options
  // are links beside a hidden options[...] input, so look for all of them
  // anywhere, preferring an option named like "Size" or "Length".
  var OPTION_SEL = 'input[type="radio"][name^="options["], select[name^="options["] option, form[action*="/cart/add"] input[type="radio"], form[action*="/cart/add"] select option, a[data-popout-option]';
  function optionName(el) {
    if (el.tagName === "A") {
      var box = el.closest("popout-select, .select-popout");
      var input = box && box.querySelector('input[name^="options["]');
      return input ? input.name : "";
    }
    return (el.tagName === "OPTION" ? el.parentElement.name : el.name) || "";
  }
  function optionValue(el) {
    return el.tagName === "A" ? el.getAttribute("data-value") || "" : el.value;
  }
  function findOption(test, nameRe, skipName) {
    var hit = null;
    var fallback = null;
    document.querySelectorAll(OPTION_SEL).forEach(function (el) {
      if (hit || el.closest("pmo-size-guide")) return;
      var name = optionName(el);
      if (!name || (skipName && name === skipName)) return;
      if (!test(norm(optionValue(el)))) return;
      if (nameRe.test(name)) hit = el;
      else if (!fallback) fallback = el;
    });
    return hit || fallback;
  }
  // Shoe charts list bare EU numbers ("42") while the options read
  // "EU 42 / US 8½", so an "EU" in front of a size is ignored either way.
  function sizeTest(want) {
    var bare = want.replace(/^eu\s*/, "");
    return function (v) {
      if (v === want) return true;
      return v.split("/").some(function (x) {
        x = x.trim();
        return x === want || x.replace(/^eu\s*/, "") === bare;
      });
    };
  }
  function findSizeChoice(size) {
    var one = findOption(sizeTest(norm(size)), /size/i);
    if (one) return [one];
    var x = splitLength(size);
    if (!x) return null;
    var s = findOption(sizeTest(norm(x.size)), /size/i);
    if (!s) return null;
    var len = norm(x.length).replace(/"/g, "");
    var l = findOption(function (v) {
      return v === len || v.indexOf(len + " ") === 0 || v.indexOf(len + "(") === 0;
    }, /length|leg|inseam/i, optionName(s));
    return l ? [s, l] : null;
  }
  function chooseOption(el) {
    if (el.tagName === "OPTION") {
      el.parentElement.value = el.value;
      el.parentElement.dispatchEvent(new Event("change", { bubbles: true }));
    } else {
      el.click();
    }
  }

  class PmoSizeGuide extends HTMLElement {
    connectedCallback() {
      var data;
      try {
        // "Natural waist" reads as just "waist" everywhere in the guide, and
        // a misspelling carried over from the old charts is put right.
        data = JSON.parse(this.querySelector("[data-sg-data]").textContent.replace(/([Nn])atural\s+([Ww])aist/g, function (m, n) {
          return n === "N" ? "Waist" : "waist";
        }).replace(/([Cc])irumference/g, "$1ircumference"));
      } catch (e) {
        return;
      }
      if (!data || !data.charts || !data.charts.length) return;
      // Opt-in, set by the Liquid from the product's vendor and tags. A chart
      // that publishes body measurements AND a secondary garment table used to
      // trip garmentKind() and tell the shopper the body numbers were the
      // garment's, which is the opposite of the truth.
      var warnGarment = this.getAttribute("data-garment-warn") === "true";
      data.charts.forEach(function (c) {
        try {
          c.garment = warnGarment ? garmentKind(c) : null;
          prepareHowTo(c);
          c.notes = chartNotes(c);
        } catch (e) {
          c.howto = {};
        }
      });
      this.data = data;
      this.units = "cm";
      this.active = 0;
      this.inputs = {};
      this.result = null;
      this.dialog = this.querySelector("dialog");
      this.body = this.querySelector("[data-sg-body]");
      var self = this;
      this.querySelector("[data-sg-open]").addEventListener("click", function () {
        var filled = self.prefill();
        self.render();
        if (self.dialog.showModal) self.dialog.showModal();
        else self.dialog.setAttribute("open", "");
        if (filled) self.calculate();
      });
      this.querySelector("[data-sg-close]").addEventListener("click", function () {
        self.dialog.close();
      });
      // Only the X closes the guide: clicking outside it or pressing Escape
      // shouldn't lose someone's measurements.
      this.dialog.addEventListener("cancel", function (e) {
        e.preventDefault();
      });
      this.dialog.addEventListener("click", function (e) {
        var unit = e.target.closest("[data-sg-unit]");
        if (unit) {
          self.saveInputs();
          self.units = unit.getAttribute("data-sg-unit");
          self.querySelectorAll("[data-sg-unit]").forEach(function (b) {
            b.setAttribute("aria-pressed", String(b === unit));
          });
          self.render();
        }
        var pick = e.target.closest("[data-sg-pick]");
        if (pick) self.pickSize(pick.getAttribute("data-sg-pick"));
      });
      // Clicking into a measurement shows how to take it.
      this.dialog.addEventListener("focusin", function (e) {
        var input = e.target.closest && e.target.closest("[data-sg-field]");
        if (!input) return;
        self.tipKey = input.getAttribute("data-sg-field");
        self.tipHold = false;
        self.showTip();
      });
      // Leaving the measurement boxes hides the tip again, unless the
      // click was on the tip itself or on the result below it: hiding the
      // tip there would move the Choose button out from under the click.
      this.dialog.addEventListener("pointerdown", function (e) {
        self.tipHold = !!(e.target.closest && e.target.closest("[data-sg-tip], [data-sg-result]"));
      });
      this.dialog.addEventListener("focusout", function (e) {
        if (!e.target.closest || !e.target.closest("[data-sg-field]")) return;
        var next = e.relatedTarget;
        if (next && next.closest && (next.closest("[data-sg-field]") || next.closest("[data-sg-tip]") || next.closest("[data-sg-result]"))) return;
        if (self.tipHold) return;
        self.resetTip();
      });
      // The size updates as they type, after a short pause.
      this.dialog.addEventListener("input", function (e) {
        if (!e.target.closest || !e.target.closest("[data-sg-field]")) return;
        clearTimeout(self.typing);
        self.typing = setTimeout(function () {
          self.calculate();
        }, 350);
      });
      // The guide sits inside the product form, so it can't use a form of
      // its own (and Enter must never add to cart).
      this.dialog.addEventListener("keydown", function (e) {
        if (e.key === "Enter" && e.target.matches("[data-sg-field]")) {
          e.preventDefault();
          clearTimeout(self.typing);
          self.calculate();
        }
      });
    }

    showTip() {
      var box = this.querySelector("[data-sg-tip]");
      var chart = this.data.charts[this.active];
      if (!box || !chart || !chart.calc || !this.tipKey) return;
      var f = chart.calc.fields[Number(this.tipKey.split(":")[1])];
      if (!f) return;
      box.innerHTML = tipHtml(f.label, (chart.howto || {})[fieldKey(f.label)]);
      box.hidden = false;
      this.markArea(fieldKey(f.label));
    }

    // Picks out the band on the small figure for the box being typed in.
    markArea(area) {
      this.querySelectorAll(".pmo-sg__band").forEach(function (b) {
        b.classList.toggle("is-on", !!area && b.getAttribute("data-area") === area);
      });
    }

    resetTip() {
      this.tipKey = null;
      this.markArea(null);
      var box = this.querySelector("[data-sg-tip]");
      if (!box) return;
      box.hidden = true;
      box.innerHTML = "";
    }

    // Fills empty boxes from the measurements saved on the collection pages.
    // True when every box now has a value, so the size can show straight away.
    prefill() {
      var chart = this.data.charts[this.active];
      if (!sharesRider(chart)) return false;
      var meas = loadRider().meas || {};
      var self = this;
      var all = true;
      chart.calc.fields.forEach(function (f, i) {
        var key = self.active + ":" + i;
        if (self.inputs[key] == null) {
          var k = riderKey(f.label);
          var v = k ? riderValue(meas[k]) : null;
          if (v != null) self.inputs[key] = v;
        }
        if (self.inputs[key] == null) all = false;
      });
      return all && !this.result;
    }

    // Saves the body measurements typed here for the collection pages.
    shareInputs() {
      var chart = this.data.charts[this.active];
      if (!sharesRider(chart)) return;
      var self = this;
      var out = {};
      chart.calc.fields.forEach(function (f, i) {
        var k = riderKey(f.label);
        var v = riderValue(self.inputs[self.active + ":" + i]);
        if (k && v != null) out[k] = Math.round(v * 10) / 10;
      });
      if (Object.keys(out).length) saveRider(out);
    }

    saveInputs() {
      var self = this;
      this.querySelectorAll("[data-sg-field]").forEach(function (input) {
        var n = parseFloat(input.value);
        self.inputs[input.getAttribute("data-sg-field")] = isNaN(n) ? null : self.units === "in" ? n * 2.54 : n;
      });
    }

    calculate() {
      this.saveInputs();
      this.shareInputs();
      var chart = this.data.charts[this.active];
      var calc = chart.calc;
      var self = this;
      var values = calc.fields.map(function (f, i) {
        return self.inputs[self.active + ":" + i];
      });
      if (values.some(function (v) { return v == null || v <= 0; })) {
        this.result = null;
      } else if (!window.PmoSizeCalc) {
        this.result = { error: "The calculator is still loading. Try again in a moment." };
      } else {
        if (calc.mode === "cover") {
          var c = window.PmoSizeCalc.coverSize(chart.tables[calc.table], calc, values);
          this.result = c.size ? { size: c.size, index: c.index, positions: [], need: values[0] + (Number(calc.add) || 0) } : { none: true, cover: true };
          return this.refresh();
        }
        var r = window.PmoSizeCalc.recommend(chart.tables[calc.table], calc, values, "regular");
        this.result = r.size ? { size: r.size, index: r.ranked[0].index, positions: r.ranked[0].positions || [] } : { none: true };
        var table = chart.tables[calc.table];
        if (r.size) {
          // Each body measurement on its own: which size would it pick? On
          // pants listed by leg length ("M Short", "M Long") only the size
          // counts here; the inseam picks the length, not the size.
          var order = [];
          rowsOf(table).slice(1).forEach(function (row) {
            var b = baseSize(row[calc.size || 0] && row[calc.size || 0].v);
            if (order.indexOf(b) < 0) order.push(b);
          });
          var labels = {};
          rowsOf(table).slice(1).forEach(function (row) {
            var v = row[calc.size || 0] && row[calc.size || 0].v;
            var x = splitLength(v);
            if (!labels[baseSize(v)]) labels[baseSize(v)] = x ? x.size : String(v);
          });
          var each = [];
          calc.fields.forEach(function (f, i) {
            if (order.length < rowsOf(table).length - 1 && LEG_RE.test(f.label)) return;
            var one = window.PmoSizeCalc.recommend(table, { size: calc.size, fields: [f] }, [values[i]], "regular");
            if (one.size) each.push({ label: f.label, size: labels[baseSize(one.size)] || one.size, rank: order.indexOf(baseSize(one.size)) });
          });
          var ranks = each.map(function (x) { return x.rank; }).filter(function (x) { return x > -1; });
          var lo = Math.min.apply(null, ranks);
          var hi = Math.max.apply(null, ranks);
          var mine = order.indexOf(baseSize(r.size));
          if (mine > -1) { lo = Math.min(lo, mine); hi = Math.max(hi, mine); }
          if (ranks.length && hi > lo) {
            this.result.span = { sizes: order.slice(lo, hi + 1), from: labels[order[lo]], to: labels[order[hi]], each: each, wide: hi - lo >= 2 };
          }
        }
      }
      this.refresh();
    }

    pickSize(size) {
      var els = findSizeChoice(size);
      if (!els) return;
      chooseOption(els[0]);
      if (els[1]) {
        // Choosing the size can redraw the options, so find the length again.
        var name = optionName(els[1]);
        var value = optionValue(els[1]);
        var again = Array.prototype.filter.call(document.querySelectorAll(OPTION_SEL), function (el) {
          return !el.closest("pmo-size-guide") && optionName(el) === name && optionValue(el) === value;
        })[0];
        chooseOption(again || els[1]);
      }
      this.dialog.close();
    }

    calcHtml(chart) {
      var calc = chart.calc;
      var u = this.units === "in" ? "in" : "cm";
      var self = this;
      var html = '<div class="pmo-sg__calc"><div class="pmo-sg__calc-head"><h3>' + esc(calc.name || "Calculate my size") + '</h3>' +
        '<a class="pmo-sg__howto" href="' + GUIDE_URL + '" target="_blank" rel="noopener">Full measuring guide' +
        '<svg width="11" height="11" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true" style="margin-left:5px;vertical-align:-1px"><path d="M4 2h6v6M10 2 3 9"/></svg>' +
        '<span class="pmo-sg__sr"> (opens in a new tab)</span></a></div>';
      var figure = figureFor(calc);
      if (figure) html += '<div class="pmo-sg__calc-body">' + miniFigureHtml(figure) + '<div class="pmo-sg__calc-inputs">';
      html += '<div class="pmo-sg__fields">';
      calc.fields.forEach(function (f, i) {
        var key = self.active + ":" + i;
        var cm = self.inputs[key];
        var shown = cm == null ? "" : u === "in" ? round1(cm / 2.54) : round1(cm);
        html += "<label>" + esc(f.label) + " (" + u + ')<input type="number" inputmode="decimal" step="0.1" min="0" data-sg-field="' + key + '" value="' + shown + '"></label>';
      });
      html += "</div>";
      // How to take a measurement: shown only while a box is in use.
      html += '<p class="pmo-sg__tip" data-sg-tip aria-live="polite" hidden></p>';
      // The size shows right under the boxes, beside the figure.
      html += '<div class="pmo-sg__out" data-sg-result aria-live="polite">' + this.resultHtml(chart) + "</div>";
      if (figure) html += "</div></div>";
      return html + notesHtml(chart) + "</div>";
    }

    // The recommendation, its tight-loose scales and any mixed-size note.
    // Redrawn on its own as they type, so the boxes keep focus.
    resultHtml(chart) {
      var calc = chart.calc;
      var html = "";
      var r = this.result;
      if (!r) html += '<p class="pmo-sg__result pmo-sg__result--wait">' + (calc.mode === "cover" ? "Enter your bike's length and your size will show here." : "Enter your measurements and your size will show here.") + "</p>";
      else if (r.error) html += '<p class="pmo-sg__result">' + esc(r.error) + "</p>";
      else if (r && r.none && r.cover) html += '<p class="pmo-sg__result">Your bike is longer than our biggest cover. Our team can help: <a href="' + CONSULT_URL + '" target="_blank" rel="noopener">get in touch</a>.</p>';
      else if (r && r.none) html += '<p class="pmo-sg__result">Those measurements fall outside this chart. Our team can help: <a href="' + CONSULT_URL + '" target="_blank" rel="noopener">book a free fit consultation</a> or get in touch.</p>';
      else if (r && r.size) {
        html += '<p class="pmo-sg__result">Your size: <strong>' + esc(r.size) + "</strong>";
        if (findSizeChoice(r.size)) html += '<button type="button" class="pmo-sg__pick" data-sg-pick="' + esc(r.size) + '">Choose ' + esc(r.size) + "</button>";
        html += "</p>";
        if (r.need) {
          var cu = this.units === "in" ? round1(r.need / 2.54) + " in" : round1(r.need) + " cm";
          html += '<p class="pmo-sg__garment">That includes ' + (this.units === "in" ? round1(calc.add / 2.54) + " in" : round1(calc.add) + " cm") + " of clearance, so you need a cover at least " + cu + " long.</p>";
        }
        var self = this, values = calc.fields.map(function (f, i) { return self.inputs[self.active + ":" + i]; });
        html += stripsHtml(calc, r, chart.tables[calc.table], values, this.units);
        requestAnimationFrame(function () { fitStrips(self); });
        html += spanHtml(r);
      }
      return html;
    }

    // Puts the new result and the highlighted size in place without
    // touching the measurement boxes.
    refresh() {
      var chart = this.data.charts[this.active];
      var out = this.querySelector("[data-sg-result]");
      var tables = this.querySelector("[data-sg-tables]");
      if (!out || !tables) return this.render();
      out.innerHTML = this.resultHtml(chart);
      tables.innerHTML = this.blocksHtml(chart);
    }

    // Just the charts, with the recommended size highlighted in every
    // table that lists it. Guide text and pictures aren't repeated here:
    // the size finder above carries the tips, figure and notes.
    blocksHtml(chart) {
      var self = this;
      var html = "";
      var found = this.result && this.result.size != null && chart.calc ? this.result : null;
      // Some charts keep the full size-by-length list hidden and show it
      // split into a sizes table and a lengths table. Show that list as one
      // size-by-length grid instead, first, and leave out the tables it
      // already covers.
      var lead = chart.calc && chart.tables[chart.calc.table];
      var promote = lead && lead.hidden && pivotHtml(lead, self.units, null) ? chart.calc.table : -1;
      var order = chart.tables.map(function (t, i) { return i; });
      if (promote > -1) order = [promote].concat(order.filter(function (i) { return i !== promote && !coveredBy(chart.tables[i], lead); }));
      order.forEach(function (i) {
        var t = chart.tables[i];
        if (!t || (t.hidden && i !== promote)) return;
        var mark = !found ? null : { fit: !found.span, span: found.span ? found.span.sizes : null };
        if (mark) { if (chart.calc.table === i) mark.index = found.index; else mark.size = found.size; }
        html += tableHtml(t, self.units, mark);
      });
      return html;
    }

    render() {
      // One chart per product: Peak Moto Ops only ever sends one, and if
      // an older entry still holds more, the first is the one shown.
      var chart = this.data.charts[0];
      // A garment-measurement chart says so before anything else.
      var html = garmentHtml(chart);
      // The calculator always comes first, above the charts.
      if (chart.calc) html += this.calcHtml(chart);
      else html += notesHtml(chart);
      html += '<div data-sg-tables>' + this.blocksHtml(chart) + "</div>";
      this.body.innerHTML = html;
      if (this.tipKey && this.tipKey.split(":")[0] === String(this.active)) this.showTip();
    }
  }

  // The same figures and measuring tips for the collection pages' size
  // finder (assets/pmo-collection.js). areas: the measurements asked for,
  // e.g. ["chest", "waist"]; the figure is the first one that covers any.
  window.PmoMeasureUI = {
    tipHtml: function (label) { return tipHtml(label); },
    figureHtml: function (areas) {
      var names = Object.keys(FIGURES);
      for (var i = 0; i < names.length; i++) {
        var fig = FIGURES[names[i]];
        if (areas.some(function (a) { return fig.areas.indexOf(a) >= 0; })) return miniFigureHtml({ fig: fig, keys: areas });
      }
      return "";
    }
  };

  customElements.define("pmo-size-guide", PmoSizeGuide);
})();
